// extracted by mini-css-extract-plugin
export var divider = "_ny-0";
export var systemMessage = "_ny-1";
export var systemMessageWrapper = "_ny-2";